import React from 'react'
import Helmet from 'react-helmet'
import {graphql, useStaticQuery} from 'gatsby'
import Layout from '../layout'
import PostListPage from '../components/PostListing/PostListPage'
import SEO from '../components/SEO'
import Hero from '../components/Blog/Hero'
import HeroImage from '../components/Blog/HeroImage'
import HeroScroll from '../components/HeroScroll'
import config from '../../data/SiteConfig'
import Pager from '../components/Pager'
import Callout from '../components/Blog/Callout'
import Rss from '../components/Blog/Rss'
import '../components/Blog/Blog.scss'
import CategoryNavigation from '../components/CategoryNavigation'

const BlogList = ({pageContext, location, data}) => {
  const { prev, next, numPages, currentPage } = pageContext
  const postEdges = data.allMarkdownRemark.edges
  const categoryList = data.allCategories.distinct

  return (
    <Layout
      location={location}
      title="Blog"
      hero={<Hero />}
      scroll={<HeroScroll />}
      heroType=""
      heroImage={<HeroImage layoutContext={pageContext.layout} />}
    >
      <div className="blog-container">
        <CategoryNavigation label="Categories" dropdownItems={categoryList} />
        <Helmet>
          <title>
            {pageContext.layout === 'post'
              ? config.metaTags.blogLanding
              : config.metaTags.videoLanding}
            {currentPage > 1 ? `${' '}(Page ${currentPage})` : ''} |{' '}
            {config.siteTitle}
          </title>
          <link rel="canonical" href={`${config.siteUrl}`} />
        </Helmet>
        <SEO postEdges={postEdges} />
        <h3 className="visually-hidden">Our Blog</h3>
        <PostListPage postEdges={postEdges} currentPage={currentPage} />
        <Pager
          next={next}
          prev={prev}
          numPages={numPages}
          currentPage={currentPage}
          type={pageContext.layout}
        />
      </div>
      <Callout />
      {pageContext.layout === 'post' ? (
        <Rss feedUrl="/rss/feed.xml" />
      ) : (
        undefined
      )}
    </Layout>
  )
}

export const pageQuery = graphql`
    query BlogQuery($skip: Int!, $limit: Int!, $regex: String!) {
      allMarkdownRemark(
        filter: {fields: {slug: {regex: $regex}}}
        limit: $limit
        skip: $skip
        sort: {fields: {date: DESC}}
      ) {
        edges {
          node {
            html
            fields {
              slug
              date
            }
            excerpt
            timeToRead
            frontmatter {
              title
              author {
                full_name
              }
              tags
              date
              layout
              length
              category
              description
              assets {
                hero
              }
              nutgraf
            }
          }
        }
      }
      allCategories: allMarkdownRemark {
        distinct(field: { frontmatter: { category: SELECT } })
      }
    }
  `

export default BlogList
